<template lang="pug">
  v-app 
    n-navbar
    //- canvas#canvasCelebrate(
    //-   style='z-index:220; position: absolute; pointer-events:none;'
    //- )
    v-container.layoutcontrol(fluid)
      v-main.pt-5
        router-view 
</template>

<script>  
import NNavbar from "@/components/AppBar/NavbarAfterLogin-v1";

export default {
  name: "App",  
  components: { 
    NNavbar,
  },   
};
</script> 